/* eslint-disable import/prefer-default-export */
export const en = {
  translation: {
    title: 'Validate electronic authorized copy',
    desc:'Enter the CSV (Secure Verification Code) and click the Validate button to check the authenticity and integrity of the electronic authorized copy of the notarial document, as well as to know subsequent legal modification notes and coordination with other public instruments.',
    placeholderCSV:'CSV Code',
    validateButton: 'Validate',
    backButton:'Back',
    okButton:'Accept',
    cancelButton:'Cancel',
    closeButton:'Close',
    actionsButton:'Actions',
    downloadButton:'Download',
    head:{
      title: 'NOTARIAL ELECTRONIC OFFICE',
    },
    footer:{
      legalNotice: 'Legal Notice',
      privacyPolicy: 'Privacy Policy',
      accessibility: 'Accessibility',
      cookiesPolicy: 'Cookies Policy',
      supportedBrowsers: 'Supported Browsers',
    },
    modalsupportedbrowsers:{
      other: 'You can access using a PC, Mac, mobile or tablet.',
    },
    actions: {
      helpButton:'View help',
      validateSignature:'Validate signature',
      download:'Download',
      downloadCombined: 'Download combined'
    },
    modalAyuda:{
      title:'Help',
      guide:'Here you can download the guide related to this section',
      section1: 'Check signature validity through the Notarial Electronic Office',
      desc1: 'To check the validity of the qualified electronic signature of the notary on the notarial document, click the <strong>Actions</strong> button and select <strong>Validate signature</strong>.',
      section2: 'Check signature validity using Adobe Acrobat Reader',
      desc2: 'To check the validity of the qualified electronic signature of the notary on the notarial document, click the <strong>Actions</strong> button and select <strong>Download</strong>. Then open the document with Adobe Acrobat Reader and click the pen icon located in the side menu. <br /><br /> In the dropdown list you can check the validity of the signature and analyze its details.',
      section3: 'Check signature validity using VALIDe',
      desc3: 'To check the validity of the qualified electronic signature of the notary on the notarial document, click the <strong>Actions</strong> button and select <strong>Download</strong>. Then use the',
      linkText: 'public VALIDe platform',},
      modalCopia:{
      title:'Electronic authorized copy',
    },
    modalErrorServicio:{
      desc: 'There is no electronic authorized copy linked to the CSV code you entered. Please check the code and try again.',
      contactSupport: 'If you continue to have problems, you can contact the support service.',
    },
    modalAdvertenciaDescarga:{
      title:'Warning',
      desc:'<strong>The notes</strong> of legal modification and coordination with other public instruments <strong>issued after the copy was issued will not be available in the document you are about to download.</strong> They only appear in the copy issuance receipt.',
    },
    modalErrorGenerico:{
      desc:'An error has occurred. Please try again.',
    },
    modalErrorValidacion:{
      title:'Signature validation error.',
      desc:'The document signature could not be validated. Please try again or contact the support service.',
    },
    modalManuales:{
      name:'Name',
    },
    modalValidacionFirma:{
      title:'Validate signature',
      firmaNotario:'QUALIFIED NOTARY SIGNATURE:',
      fechaFirma:'SIGNATURE DATE:',
      fechaValidacion:'VALIDATION DATE:',
      estadoFirma:'SIGNATURE STATUS:',
      validacionFirma:'Electronic signature validation of the General Council of Notaries',
      validada:'Validated',
      noValidada:'Not valid',
      contenido:'Document content',
      alterado:'altered',
      noAlterado:'not altered',
      certificadoFirmante:'Signer certificate',
      caducado:'expired',
      noCaducado:'not expired',
      revocado:'revoked',
      noRevocado:'not revoked',
      certificadoCa:'issued by a trusted certification authority (CA)',
      noCertificadoCa:'not issued by a trusted CA',
    },
  },
};
